import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, timer } from 'rxjs';

@Component({
	selector: 'ui-timeout',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './timeout.component.html',
	styleUrl: './timeout.component.scss',
})
export class TimeoutComponent {
	@Input() idleTimeoutSeconds = 900; // default 15 mins
	@Input() warningBeforeSeconds = 300; // default warning 5 minutes before timeout
	pageTimingOut = false;

	constructor(private bnIdle: BnNgIdleService, private router: Router) { }

	private timeoutSub?: Subscription;
	private idleSub?: Subscription;

	ngOnInit(): void {
		if (!window.location.href.includes('sessionExpired')) {
			this.startTimer();
		}
	}

	startTimer(): void {
		console.log("timers started");

		// @ts-ignore // to ignore timer$ being undefined error
		if (this.bnIdle.timer$) { // bn-idle calls "this.timer$.unsubscribe();" but never checks if timer$ is defined so we get errors if we dont check
			this.bnIdle.stopTimer();
		}

		this.idleSub = this.bnIdle.startWatching(this.idleTimeoutSeconds).subscribe((res) => {
			console.log("session times out");
			this.pageTimingOut = false;
			// The certificate journey does not go through the landing page, so it never stores "journey".
			// Store it here, so that the session expired page returns the user to the certificate journey.
			if (this.router.url.startsWith('/start/order_a_copy_certificate')) {
				sessionStorage.setItem('journey', 'order_a_copy_certificate');
			}
			this.router.navigate(['/sessionExpired']);
		});

		this.timeoutSub = timer((this.idleTimeoutSeconds - this.warningBeforeSeconds) * 1000).subscribe(() => {
			this.pageTimingOut = true;
		});
	}

	extendSession(): void {
		this.clearTimers();
		this.startTimer();
		this.pageTimingOut = false;
	}

	clearTimers(): void {
		this.timeoutSub?.unsubscribe();
		this.idleSub?.unsubscribe();
		if (this.bnIdle) this.bnIdle.stopTimer();
	}

	ngOnDestroy(): void {
		this.clearTimers();
	}
}
